import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '@tribeplatform/react-sdk';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
export const MemberPill = ({ member }) => {
    var _a, _b;
    const { Link } = useRouter();
    if (!(member === null || member === void 0 ? void 0 : member.name)) {
        return null;
    }
    return (_jsx(Link, { href: member === null || member === void 0 ? void 0 : member.relativeUrl, className: "rounded-full", translate: "no", children: _jsx(Badge, { variant: "secondary", rounded: true, className: "ps-1", leadingIcon: _jsx(Avatar, { size: "xs", src: (_b = (_a = member === null || member === void 0 ? void 0 : member.profilePicture) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.thumb, name: member === null || member === void 0 ? void 0 : member.name }, void 0), children: member === null || member === void 0 ? void 0 : member.name }, void 0) }, void 0));
};
//# sourceMappingURL=MemberPill.js.map